import type { Column } from '@rundown-studio/types'
import { useUser } from '../../user'

type UseIsPrivateNotesAvailableParams = {
  column: Pick<Column, 'name' | 'privateUid'>
}

export const useIsPrivateNotesColumn = ({
  column,
}: UseIsPrivateNotesAvailableParams) => {
  const { data: user } = useUser()

  if (!column) return false

  return (
    column?.name.toLowerCase().includes('private notes') &&
    column?.privateUid === user?.uid
  )
}
